import React from "react";
import {CardText,} from "reactstrap";
import moment from "moment/moment";

const totalRequestCount = (broadcastDetail) => {
    if (broadcastDetail && broadcastDetail.hasOwnProperty("availability") && Array.isArray(broadcastDetail.availability) && broadcastDetail.availability[0].hasOwnProperty("group_request_count")) {
        let group_request_count = broadcastDetail.availability[0].group_request_count;
        let one_on_one_request_count = 0;

        if (broadcastDetail.availability[0].hasOwnProperty("one_on_one_request_count")) {
            one_on_one_request_count = broadcastDetail.availability[0].one_on_one_request_count
        }

        let requests = group_request_count + one_on_one_request_count;

        return requests > 1 ? `${requests} requests` : `${requests} request`
    } else {
        return `0 request`;
    }
};

const totalViewCount = (broadcastDetail) => {

    switch (broadcastDetail.type) {
        case "available":
        case "awaiting":
            return totalRequestCount(broadcastDetail);
        default:
            if (broadcastDetail && broadcastDetail.hasOwnProperty("viewers_count")) {
                let viewers_count = broadcastDetail.viewers_count;
                return viewers_count > 1 ? `${viewers_count} views` : `${viewers_count} view`
            } else {
                return `0 view`;
            }
    }
};

const sessionHumanReadableTiming = (broadcastDetail) => {
    switch (broadcastDetail.type) {
        case "live":
            if (broadcastDetail && broadcastDetail.hasOwnProperty("broadcast_start_at")) {
                return moment.utc(broadcastDetail.broadcast_start_at).local().fromNow();
            } else {
                return "NA";
            }
        case "private":
            if (broadcastDetail && broadcastDetail.hasOwnProperty("private") && broadcastDetail.private.hasOwnProperty("start_at")) {
                return moment.utc(broadcastDetail.private.start_at).local().fromNow();
            } else {
                return "NA";
            }
        case "available":
        case "awaiting":
            if (broadcastDetail && broadcastDetail.hasOwnProperty("availability") && Array.isArray(broadcastDetail.availability) && broadcastDetail.availability[0].hasOwnProperty("availability_start_at")) {
                return moment.utc(broadcastDetail.availability[0].availability_start_at).local().fromNow();
            } else {
                return "NA";
            }
        default:
            return "NA";
    }
};

const emptyView = () => {
    return (
        <CardText>
            <span className="text-left">0 view</span>
            <span style={{"margin": 5, fontSize: 12}}>&#8226;</span>
            <span className="text-right">NA</span>
        </CardText>
    );
};

const BroadcastListViewComponent = (props) => {
    const {broadcastDetail} = props;

    if (broadcastDetail && broadcastDetail.hasOwnProperty("type")) {
        switch (broadcastDetail.type) {
            case "live":
            case "private":
            case "available":
            case "awaiting":
                return (
                    <CardText>
                    <span
                        className="text-left">{totalViewCount(broadcastDetail)}</span>
                        <span style={{"margin": 5, fontSize: 12}}>&#8226;</span>
                        <span
                            className="text-right">{sessionHumanReadableTiming(broadcastDetail)}</span>
                    </CardText>
                );
            default:
                return emptyView()
        }
    } else {
        return emptyView()
    }
}

export default BroadcastListViewComponent;